/*
  Nubra 2.0 — placeholder „typewriter” pentru câmpurile de căutare (portat din BLINK).
  Uz: <input data-nb-typewriter="Black Opium|Sauvage|Good Girl" data-nb-prefix="ex. " placeholder="Ce parfum iubești?">
  Placeholder-ul static rămâne eticheta accesibilă; animația îl rescrie doar cât câmpul e liber.
  Se oprește la focus / când se tastează și nu rulează cu prefers-reduced-motion.
*/
(() => {
  if (window.__nbTypewriter) return;
  window.__nbTypewriter = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function run(input) {
    if (input.dataset.nbTwInit) return;
    input.dataset.nbTwInit = '1';
    const words = (input.dataset.nbTypewriter || '').split('|').map((w) => w.trim()).filter(Boolean);
    if (!words.length || reduce.matches) return;
    const base = input.getAttribute('placeholder') || '';
    const prefix = input.dataset.nbPrefix ?? 'ex. ';
    let w = 0, i = 0, deleting = false, timer = null, paused = true;

    // Maison d'Esteban GEO (P13.21): pentru non-RO nu animăm originale; placeholder-ul neutru vine din est-geo.js (data-est-geo-ph).
    const geoOff = () => document.documentElement.classList.contains('est-geo-nonro');
    function tick() {
      if (paused) return;
      if (geoOff()) { paused = true; clearTimeout(timer); input.setAttribute('placeholder', input.dataset.estGeoPh || base); return; }
      const word = words[w];
      i += deleting ? -1 : 1;
      input.setAttribute('placeholder', prefix + word.slice(0, i) + (deleting || i < word.length ? '|' : ''));
      let delay = deleting ? 45 : 85 + Math.random() * 60;
      if (!deleting && i === word.length) { delay = 1600; deleting = true; }
      else if (deleting && i === 0) { deleting = false; w = (w + 1) % words.length; delay = 350; }
      timer = setTimeout(tick, delay);
    }
    function stop() { paused = true; clearTimeout(timer); input.setAttribute('placeholder', (geoOff() && input.dataset.estGeoPh) || base); }
    function resume() {
      if (geoOff()) return;
      if (!paused || input.value || (document.activeElement === input && !keep) || reduce.matches) return;
      paused = false; timer = setTimeout(tick, 700);
    }
    const keep = input.hasAttribute('data-nb-tw-keep'); // Fundație: continuă și cu focus, cât câmpul e gol (panoul de căutare mobil)
    if (!keep) input.addEventListener('focus', stop);
    input.addEventListener('input', () => { if (input.value) stop(); else if (keep) resume(); });
    input.addEventListener('blur', resume);
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? resume() : stop()))) : null;
    io ? io.observe(input) : resume();
  }

  function init(root) { (root || document).querySelectorAll('input[data-nb-typewriter]').forEach(run); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
